<template lang="pug">
    v-layout
        v-flex(md2)
        v-flex(md8)
            v-data-table.elevation-1(:items='finiquitoData' hide-actions='' hide-headers='')
                template(slot='items' slot-scope='props')
                    td {{ props.item.type }}
                    td.text-xs-right {{ props.item.amount }}
</template>

<script>
export default {
    name: 'finiquito-detail',
    props: {
        finiquitoData:{
            type:Object,
            required: false,
        }
    },
    data: function(){
        return {
            finiquito:[
                {
                    type:'remuneraciones pendientes',
                    amount:'$3000',
                },
                {
                    type:'test',
                    amount:'$2000'
                }
            ],
            desserts: [
                {
                name: 'Frozen Yogurt',
                calories: 159,
                fat: 6.0,
                carbs: 24,
                protein: 4.0,
                iron: '1%'
                },
                {
                name: 'Ice cream sandwich',
                calories: 237,
                fat: 9.0,
                carbs: 37,
                protein: 4.3,
                iron: '1%'
                }]
        }
    },
    // computed: {},
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        // -- Vuex mappings
    },
    // watch: {},
    // components: {},
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>